export const FEATURE = {
  HAS_MEDIA_MONITORING_PRODUCT: "has_media_monitoring_product",
  HAS_SEARCH_PRODUCT: "has_search_product",
  HAS_REPORT_PRODUCT: "has_report_product",
  HAS_READ_EXPIRED_SEARCHES_MENTIONS_FEATURE:
    "has_read_expired_searches_mentions_feature",
  HAS_EXCEL_EXPORT_FEATURE: "has_excel_export_feature",
  HAS_SAVE_STATIC_REPORTS_FEATURE: "has_save_static_reports_feature",
  HAS_SHOW_FULL_TRANSCRIPT_FEATURE: "has_show_full_transcript_feature",
  HAS_JSON_API_FEATURE: "has_json_api_feature",
  HAS_RSS_FEATURE: "has_rss_feature",
  HAS_FULL_HISTORY_FEATURE: "has_full_history_feature",
  PARTNER_CUSTOMER: "partner_customer",
  HAS_REQUEST_TRANSCRIPT_FEATURE: "has_request_transcript_feature",
  HAS_PPT_FEATURE: "has_ppt_feature",
  HAS_FULL_TRANSCRIPTS_VIA_JSON_API_FEATURE:
    "has_full_transcripts_via_json_api_feature",
  SHOW_PR_VALUE: "show_pr_value",
  HAS_YOUTUBE_TEXT_SEARCH_FEATURE: "has_youtube_text_search_feature",
  HAS_TIKTOK_TEXT_SEARCH_FEATURE: "has_tiktok_text_search_feature",
  HAS_INSTAGRAM_TEXT_SEARCH_FEATURE: "has_instagram_text_search_feature",
  BYPASS_DOMAIN_CHECKS: "bypass_domain_checks",

  CAN_CREATE_SEARCHES: "can_create_searches",
  CAN_MANAGE_ACCOUNT: "can_manage_account",
  CAN_MANAGE_USERS: "can_manage_users",

  DISPLAY_INSIGHTS: "display_insights",

  KEYWORD_SEARCH_SUGGESTIONS: "keyword_search_suggestions",

  HAS_HIGH_REACH_MENTIONS_FEATURE: "has_high_reach_mentions_feature",

  HAS_API_ACCESS: "has_monitor_api_v1",

  HAS_SEARCH_API_ACCESS: "has_search_api_v1",

  HAS_FORCE_SSO_LOGIN_FEATURE: "has_force_sso_login_feature",
} as const;

export type FeatureType = (typeof FEATURE)[keyof typeof FEATURE];
